module.exports = __webpack_public_path__ + "static/media/YociusProductionsSig.372f6884.png";